/* eslint-disable scanjs-rules/property_localStorage, scanjs-rules/identifier_localStorage */

export const RESERVED_KEYS = {
  HIDDEN_CALL: 'hiddenCall',
  EVENT_CONNECTIONS: 'eventConnections',
  PFMA_SESSIONS: 'pfma_sessions',
  VWR_SESSION: 'vwr_session',
};
const SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000;

export interface Session {
  account_token: string;
  created_at?: number;
  session_token: string;
}

interface SessionStore {
  [group: string]: Session;
}

export const clearLocalStorage = () => {
  window.localStorage.clear();
};

export const get = (key: string) => {
  const storedValue = window.localStorage.getItem(key);
  if (storedValue) {
    try {
      const value = JSON.parse(storedValue);
      return value;
    } catch (error) {
      return null;
    }
  }
  return null;
};

export const set = (key: string, value: unknown) => {
  const storedValue = JSON.stringify(value);
  return window.localStorage.setItem(key, storedValue);
};

/* V2 PFMA SESSIONS */

const getSessionStore = (): SessionStore => {
  return get(RESERVED_KEYS.PFMA_SESSIONS) || {};
};

export const addSession = (newSession: Session, group: string) => {
  if (!newSession.account_token) throw new Error('Invalid session');
  newSession.created_at = newSession.created_at || Date.now();
  const sessions = getSessionStore();
  sessions[group] = newSession;
  set(RESERVED_KEYS.PFMA_SESSIONS, sessions);
};

export const getSessions = (): Session[] => {
  const sessions: Session[] = [];

  try {
    const storedSessions = getSessionStore();
    Object.keys(storedSessions).forEach((group) => {
      const session = storedSessions[group];
      if (session.created_at + SEVEN_DAYS_IN_MS < Date.now()) {
        removeSession(group);
        return;
      }

      delete session.created_at;
      sessions.push(session);
    });
  } catch (e) {
    console.error(e);
  }
  return sessions;
};

const removeSession = (group: string) => {
  const sessions = getSessionStore();
  delete sessions[group];
  set(RESERVED_KEYS.PFMA_SESSIONS, sessions);
};
